// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"2":"4d6c3cd4","181":"20379d02","213":"323392a6","349":"8416cdd7","388":"753e5411","405":"f5dd38de","442":"ec77c7e7","488":"afd6e9c2","596":"8a7cfdb5","732":"e04df595","748":"eb3819d4","762":"c863f8ae","814":"8cf07c56","841":"76f9e6ac","885":"7acce19b"}[chunkId] + ".chunk.js";
};